//Have the list of curve lp tokens
//Note when add new address make sure to add in uppercase to match with other condition
let CurveLpTokenAddressList = new Array(
  '0X6C3F90F043A72FA612CBAC8115EE7E52BDE6E490', //DAI/USDC/USDT(3CRV) - 1
  '0XFD2A8FA60ABD58EFE3EEE34DD494CD491DC14900', //ANKRCRV - 2
  '0XAA17A236F2BADC98DDC0CF999ABB47D47FC0A6CF', //ETH/AETH -3
  '0X3B3AC5386837DC563660FB6A0937DFAA5924333B', //YDAI/YUSDC/YUSDT/YBUSD - 4
  '0X845838DF265DCD2C412A1DC9E959C7D08537F8A2', //CDAI/CUSDC - 5
  '0X194EBD173F6CDACE046C53EACCE9B953F28411D1', //EURS/SEUR - 6
  '0XB19059EBB43466C323583928285A49F558E572FD', //HBTC/WBTC - 7
  '0X5282A4EF67D9C33135340FB3289CC1711C13638C', //CYDAI/CYUSDC/CYUSDT - 8
  '0XCEE60CFA923170E4F8204AE08B4FA6A3F5656F3A', //LINK/SLINK - 9
  '0XD905E2EAEBE188FC92179B6350807D8BD91DB0D8', //DAI/USDC/USDT/PAX - 10
  '0X49849C98AE39FFF122806C06791FA73784FB3675', //RENBTC/WBTC - 11
  '0X53A901D48795C58F485CBB38DF08FA96A24669D5', //ETH/RETH - 12
  '0X02D341CCB60FAAF662BC0554D13778015D1B285C', //ADAI/ASUSD -13
  '0X075B1BB99792C9E1041BA13AFEF80C91A1E70FB3', //RENBTC/WBTC/SBTC - 14
  '0XA3D87FFFCE63B53E0D54FAA1CC983B7EB0B74A9C', //ETH/SETH - 15
  '0X06325440D014E39736583C165C2963BA99FAF14E', //ETH/STETH - 16
  '0XC25A3A3B969415C80451098FA907EC722572917F', //DAI/USDC/USDT/SUSD - 17
  '0XCA3D75AC011BF5AD07A98D02F18225F9BD9A6BDF', //USD-BTC-ETH - 18
  '0X9FC689CCADA600B6DF723D9E47D84D76664A1F23', //CDAI/CUSDC/USDT - 19
  '0XDF5E0E81DFF6FAF3A7E52BA697820C5E32D806A8', //YDAI/YUSDC/YUSDT/YTUSD - 20
  '0X571FF5B7B346F706AA48D696A9A4A288E9BB4091' //CYDAI/CYUSDC/CYUSDT - 21
);

export default CurveLpTokenAddressList;
